/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import Styles from '../../css/GoGreenPage.module.css';
import { isStrEmptyOrNull } from '../../common/UtilityFunctions';

function formatAsDate(date: string) {
  //"YYYY-MM-DD HH:mm:ss.173"
  if (isStrEmptyOrNull(date)) return '';
  const timezoneName = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    timeZoneName: 'short',
  })
    .formatToParts()
    .find((i) => i.type === 'timeZoneName').value;
  const newdate = new Date(date + timezoneName);
  return newdate.toLocaleString('en-US', {
    hour12: false,
    timeZone: 'America/Los_Angeles',
  });
}

const esignDocTrackingListTable = (list: UnknownESignDocTrackingListResponse, docName?: string) => {
  return (
    <table className={Styles.goGreenTable}>
      <thead>
        <tr>
          <th scope='col'>Borrower Name</th>
          <th scope='col'>Document Name</th>
          <th scope='col'>Sent Date</th>
        </tr>
      </thead>
      <tbody>
        {list?.docList?.map(
          (row) =>
            !isStrEmptyOrNull(row.fullName) &&
            (!isStrEmptyOrNull(docName) ? row.docName === docName : true) && (
              <tr key={row.id}>
                <td align='left'>{row.fullName}</td>
                <td align='left'>{row.docName}</td>
                <td align='left'>{formatAsDate(row.formSentDate)}</td>
              </tr>
            ),
        )}
      </tbody>
    </table>
  );
};

export default esignDocTrackingListTable;
